export default __webpack_public_path__ + "static/media/vire20.237e2dcd.jpg";